function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useEffect, useState } from 'react';
import { Button, Popover, useOverlayContext, useStateInRef } from 'seagull';
import ServicePicker from "../ServiceCreation/ServicePicker/ServicePicker";
import { useFeatureFlags } from "../../hooks/useFeatureFlags";
import { serviceTemplateModel } from "../../models";
import { useActiveServiceTemplates } from "../../hooks/reactQuery/queries/useActiveServiceTemplates";
import { serviceFromServiceTemplate } from "../ServiceCreation/ServicePicker/ServicePicker.utils";
import { useStoreStatic } from "../../contexts";
import { selectors } from "../../store/state-selectors";
import { NewServiceType, SelectNewServiceTypeModal } from "./SelectNewServiceTypeModal/SelectNewServiceTypeModal";
import ServiceBuilder from "../ServiceCreation/ServiceBuilder/ServiceBuilder";
import { handlePromise } from "../../infra/utils";
import { useServiceTemplateApi } from "../../hooks/useServiceTemplateApi";
import { AddServicesPopover } from "./AddServicesPopover/AddServicesPopover";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export function AddServicesButton(props) {
  const {
    agreementData,
    disabled,
    testId = '',
    text = 'Add services',
    onClick,
    onServicesAdded
  } = props;
  const {
    showModal,
    startLoader,
    stopLoader,
    showErrorToast
  } = useOverlayContext();
  const {
    ADD_SERVICES_AUTOCOMPLETE
  } = useFeatureFlags();
  const serviceTemplateApi = useServiceTemplateApi();
  const {
    data,
    isLoading,
    refresh
  } = useActiveServiceTemplates();
  const getRefresh = useStateInRef(refresh);
  const [anchorEl, setAnchorEl] = useState(null);
  const {
    getState
  } = useStoreStatic();
  const isOpen = !!anchorEl;
  useEffect(() => {
    if (isOpen) {
      getRefresh()();
    }
  }, [isOpen]);
  async function addServices(event) {
    onClick === null || onClick === void 0 || onClick();
    if (ADD_SERVICES_AUTOCOMPLETE) {
      setAnchorEl(event.currentTarget);
    } else {
      const newServices = await showModal({
        closeOnClickOutside: true,
        closeOnEscapeKey: true,
        content: p => /*#__PURE__*/_jsx(ServicePicker, _objectSpread({
          agreementData: agreementData
        }, p))
      });
      if (!newServices || newServices.length === 0) return;
      onServicesAdded(newServices);
    }
  }
  function handleClose() {
    setAnchorEl(null);
  }
  function selectServiceTemplate(serviceTemplate) {
    const service = serviceFromServiceTemplate({
      serviceTemplate,
      agreementData,
      businessSettings: selectors.user.businessSettings(getState())
    });
    handleClose();
    onServicesAdded([service]);
  }
  async function createNewServiceTemplate() {
    const newServiceType = await showModal({
      closeOnClickOutside: true,
      closeOnEscapeKey: true,
      content: p => /*#__PURE__*/_jsx(SelectNewServiceTypeModal, _objectSpread({}, p))
    });
    if (!newServiceType) return;
    showModal({
      closeOnEscapeKey: true,
      content: p => /*#__PURE__*/_jsx(ServiceBuilder, _objectSpread({
        serviceNameBlacklist: data ? data.map(s => s.name) : [],
        agreementData: agreementData,
        serviceOrigin: agreementData.isActiveAgreement() ? 'agreement' : 'draft',
        isCreatingBundle: newServiceType === NewServiceType.Bundle,
        isFreshlyAdded: agreementData.isActiveAgreement(),
        onSave: async output => {
          const body = serviceTemplateModel.fromService(output);
          const loaderName = 'createNewServiceLoader';
          startLoader(loaderName);
          const result = await handlePromise(serviceTemplateApi.create(body));
          if (result.success) {
            await refresh({
              throwOnError: false
            });
            const newServiceTemplate = serviceTemplateModel.setId(body, result.data.id);
            selectServiceTemplate(newServiceTemplate);
          } else {
            showErrorToast('Failed to create service');
          }
          stopLoader(loaderName);
          return result;
        }
      }, p))
    });
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Button, {
      type: "button",
      disabled: disabled,
      "data-testid": testId,
      onClick: addServices,
      children: text
    }), ADD_SERVICES_AUTOCOMPLETE && /*#__PURE__*/_jsx(Popover, {
      anchorEl: anchorEl,
      open: isOpen,
      anchorOrigin: {
        vertical: -8,
        horizontal: 'center'
      },
      transformOrigin: {
        vertical: 'bottom',
        horizontal: 'center'
      },
      onClose: handleClose,
      children: /*#__PURE__*/_jsx(AddServicesPopover, {
        testId: testId,
        isLoading: isLoading,
        serviceTemplates: data,
        onServiceTemplateSelected: selectServiceTemplate,
        onCreateNew: createNewServiceTemplate
      })
    })]
  });
}